import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({ palette }) => ({
  container: {
    display: "flex",
    alignContent: "center",
    justifyContent: "space-between",
    margin: "0 24px 24px 24px",
    position: "relative",
  },
  newChat: {
    margin: 0,
    width: "36px",
    height: "36px",
    background: palette.primary.main,
    color: "white",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
  },
  chatArrow: {
    position: "absolute",
    top: "35px",
    right: "45px",
  },
}));
